export default [
  {
    sort: 1,
    name: 'INBOX',
    icon: 'ri-mail-line text-primary',
    title: 'inbox',
  },
  {
    sort: 2,
    name: 'Drafts',
    icon: 'ri-draft-line',
    title: 'drafts',
  },
  {
    sort: 3,
    name: 'Sent',
    icon: 'ri-send-plane-2-line',
    title: 'sent',
  },
  {
    sort: 4,
    name: 'Spam',
    icon: 'ri-spam-line',
    title: 'spam',
  },
  {
    sort: 5,
    name: 'Trash',
    icon: 'ri-delete-bin-line text-danger',
    title: 'trash',
  },
]
